export class WatchlistVariables {
}
WatchlistVariables.WATCHLIST = "Watchlist";
WatchlistVariables.OVERVIEW = "Overview";
WatchlistVariables.WATCHLIST_BREADCRUMBS = "Force Watchlist";
